import React, { useEffect, useState, useMemo } from "react";
import { doctimeslot, not_available } from "../../../text/apidata";
import axios from "axios";
import "../../style/page/tabs/notavailable.scss";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { revertnotavailable } from "../../redux/reducer/counterslice";
import Swal from "sweetalert2";

function NotAvailable(props) {
  const editdoctorid = useSelector((state) => state.counter.edituserdoctorid);
  const dispatch = useDispatch();
  var date = new Date(),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  // console.log([date.getFullYear(), mnth, day].join("-"));
  var date = [date.getFullYear(), mnth, day].join("-");
  // console.log(date, "data");

  const [currentdate, setcurrentdate] = useState(date);

  let array1 = [];
  const current = new Date();
  const [slotarray, setslotarray] = useState([]);
  const [test, settest] = useState([]);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 7);
  const [values, setValues] = useState([tomorrow]);
  const [postData, setPostData] = useState(false);
  const [revertNotAvailable, setRevertNotAvailable] = useState(false);
  const [getNotAvailableData, setGetNotAvailableData] = useState(true);
  const [showWeekData, setShowWeekData] = useState("false");
  const revertAV = useSelector((state) => state.counter.revertnotavailable);
  useEffect(() => {
    setTimeout(() => {
      // console.log(showWeekData,"first")
      // if (getNotAvailableData == true || showWeekData=="true") {
        props.loaderchange("true");
        axios({
          method: "get",
          url: not_available,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            doctor: editdoctorid,
            week_data:showWeekData
          },
        })
          .then((res) => {
            settest(res.data.data);
            console.log(res.data.data, "testoins");
            res.data.data.map((element) => {
              //   console.log(element.slot);
              setslotarray((prev) => [...prev, element.date]);
            });
            setGetNotAvailableData(false);
            // const numAscending = [...res.data.data].sort((a, b) => a.day - b.day);
            // console.log(numAscending);

            settableheaderdata(res.data.data);
            props.loaderchange("false");
          })
          .catch((error) => {
            // alert("kjhk")
            console.log(error);
            setGetNotAvailableData(false);
            props.loaderchange("false");
          });
      // }
    }, 500);
  }, [getNotAvailableData,showWeekData]);

  useEffect(() => {
    setTimeout(() => {
      console.log(values, postData, "true");
      if (values != undefined && postData == true) {
        props.loaderchange("true");
        let finaldatelist = [];
        for (let i of values) {
          const inputDate = new Date(i);
          const year = inputDate.getFullYear();
          const month = String(inputDate.getMonth() + 1).padStart(2, "0");
          const day = String(inputDate.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;
          finaldatelist.push(formattedDate);
        }

        let data = {
          date: finaldatelist,
          doctor: editdoctorid,
        };
        console.log(data, "testtins");
        axios({
          method: "post",
          url: not_available,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          data: data,
        })
          .then((res) => {
            // settest(res.data.data);
            console.log(res.data.data, "post");
            setPostData(false);
            setGetNotAvailableData(true);
            props.loaderchange("false");
          })
          .catch((error) => {
            // alert("kjhk")
            console.log(error, "postnotavailable");
            setPostData(false);
            props.loaderchange("false");
          });
      }
    }, 500);
  }, [postData]);
  const postdates = (e) => {
    setPostData(true);
    e.preventDefault();
  };
  const revertnotavailablefunc = (date, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to make this date available ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setRevertNotAvailable(true);
        dispatch(revertnotavailable({ date: date, id: id }));
      }
    });
  };
  useEffect(() => {
    setTimeout(() => {
      if (revertNotAvailable == true) {
        props.loaderchange("true");
        let data = {
          date: revertAV.date,
          is_active: false,
        };
        console.log(data, "testtins");
        axios({
          method: "put",
          url: not_available + revertAV.id + "/",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          data: data,
        })
          .then((res) => {
            settest(res.data.data);
            console.log(res.data.data, "testoins");
            setRevertNotAvailable(false);
            props.loaderchange("false");
            setGetNotAvailableData(true);
          })
          .catch((error) => {
            // alert("kjhk")
            console.log(error, "put_method");
            setRevertNotAvailable(false);
            props.loaderchange("false");
          });
      }
    }, 500);
  }, [revertNotAvailable]);
  return (
    <>
      <div className="maincontainer_time">
        <div className="timeslot_v">
          <div className="table-content-timeslot">
            <div className="table-timeslot">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div
                      class="col"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div class="text-left mt-3 px-3 py-1 mx-1">
                        <div className="datepicker">
                          <DatePicker
                            multiple
                            value={values}
                            onChange={setValues}
                            // minDate={new Date()}
                          />
                        </div>
                      </div>{" "}
                      <div className="datesubmit">
                        <button
                          className="button_submit"
                          onClick={(e) => {
                            postdates(e);
                          }}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="showdata">
                        <button
                          className={showWeekData=="true"?"toggle_weekdata_active":"toggle_weekdata_inactive"}
                          onClick={(e) => {
                            console.log(showWeekData,"show")
                            if (showWeekData=="true"){
                            setShowWeekData("false");
                            }
                            else{
                            setShowWeekData("true");
                            }
                          }}
                        >
                          Next 7 days
                        </button>
                      </div>
                      
                    </div>
                    <div class="col">
                      {/* <div
                        class="row"
                        style={{ float: "right", padding: "20px" }}
                      >
                        <div class="color1"></div>
                        <p class="col">Not Available</p>
                      </div> */}
                      {/* <div
                        class="row"
                        style={{ float: "right", padding: "20px" }}
                      >
                        <div class="color2"></div>
                        <p class="col">Available</p>
                      </div> */}
                    </div>
                  </div>
                  {showWeekData=="true"?
                  <div class="token-slot mt-2">
                    <Box sx={{ flexGrow: 1 }}>
                      {(tableheaderdata.length > 0 &&
                        tableheaderdata.map((time) => {
                          console.log("week data")
                          return (
                            <>
                              <button
                                class="h4"
                                style={{
                                  color:
                                    time.available == true
                                      ? "green"
                                      : "black",
                                  fontWeight: 700,
                                  border:
                                    time.available == true
                                      ? "1px solid green"
                                      : "1px solid gray",
                                  border: "1px solid green",
                                  backgroundColor:
                                    time.available == true
                                      ? "white"
                                      : "gray",
                                  width: "100px",
                                  marginLeft: "20px",
                                  borderRadius: "7px",
                                  fontSize: "16px",
                                  padding: "7px",
                                }}
                                disabled={true}
                              >
                                {String(time.date)}
                              </button>
                            </>
                          );
                        })) || (
                        <p
                          style={{
                            fontSize: 20,
                            position: "relative",
                            width: 80,
                            top: "80px",
                            margin: "auto",
                          }}
                        >
                          No Data
                        </p>
                      )}
                    </Box>
                  </div>:
                  <div class="token-slot mt-2">
                    <Box sx={{ flexGrow: 1 }}>
                      {(tableheaderdata.length > 0 &&
                        tableheaderdata.map((time) => {
                          console.log(time, "rint time");
                          return (
                            <>
                              <button
                                class="h4  "
                                style={{
                                  // color:
                                  //   time.status == "0"
                                  //     ? "green"
                                  //     : time.status == "1"
                                  //     ? "black"
                                  //     : time.status == "2"
                                  //     ? "black"
                                  //     : "",
                                  fontWeight: 700,
                                  // border:
                                  //   time.status == "0"
                                  //     ? "1px solid green"
                                  //     : time.status == "1"
                                  //     ? "1px solid gray"
                                  //     : time.status == "2"
                                  //     ? "1px solid gray"
                                  //     : "",
                                  border: "1px solid green",
                                  // backgroundColor:
                                  //   time.status == "0"
                                  //     ? "white"
                                  //     : time.status == "1"
                                  //     ? "gray"
                                  //     : time.status == "2"
                                  //     ? "gray"
                                  //     : "",
                                  width: "100px",
                                  marginLeft: "20px",
                                  borderRadius: "7px",
                                  fontSize: "16px",
                                  padding: "7px",
                                }}
                                onClick={(e) => {
                                  revertnotavailablefunc(time.date, time.id);
                                }}
                              >
                                {String(time.date)}
                              </button>
                            </>
                          );
                        })) || (
                        <p
                          style={{
                            fontSize: 20,
                            position: "relative",
                            width: 80,
                            top: "80px",
                            margin: "auto",
                          }}
                        >
                          No Data
                        </p>
                      )}
                    </Box>
                  </div>
                  }
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotAvailable;
